_ = require 'underscore'
PluginButtonView = require 'app/scripts/views/plugin/plugin-button-view'
t = require('app/scripts/views/internal/teacup-with-helpers')()
{ track, trackUe } = require '@trello/analytics'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

template = t.renderable ({ icon, text, monochrome }) ->
  lightBrightness = @model.get('prefs').backgroundBrightness == 'light'
  coloredIcon =
    if _.isString(icon)
      iconColor = if lightBrightness then '000' else 'fff'
      t.addRecolorParam(icon, "?color=#{ iconColor }")
    else if lightBrightness && _.isString(icon?.light)
      icon.light
    else if !lightBrightness && _.isString(icon?.dark)
      icon.dark
  recolorable = _.isString(icon) || monochrome != false
  if coloredIcon?
    t.span '.board-header-btn-icon.icon-sm.plugin-icon',
      class: t.classify({
        recolorable: recolorable
        'mod-reset': monochrome == false
        'mod-invert': recolorable && !lightBrightness
      })
      style: t.stylify
        'background-image': t.urlify coloredIcon
  t.span '.board-header-btn-text', ->
    t.text text
  return

module.exports = class PluginHeaderButtonView extends PluginButtonView
  className: ->
    if @options.pluginButton?.icon?
      'board-header-btn'
    else
      'board-header-btn board-header-btn-without-icon'
  template: template

  trackClick: (pluginButton) ->
    track("Board Header", "Board Plugin Button", pluginButton.text)
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', pluginButton.idPlugin)
    sendPluginUIEvent(pluginButton.idPlugin, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'boardScreen'
      actionSubjectId: 'boardButton'
      objectType: 'powerUp'
      objectId: pluginButton.idPlugin
    })
